import { useEffect, useRef, useState } from "react";
import { fileUrl } from "../../lib/api";

const useFitBox = (ratio) => {
  const ref = useRef(null);
  const [box, setBox] = useState({ w: 0, h: 0 });
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const fit = () => {
      const cw = el.clientWidth;
      const ch = el.clientHeight;
      if (!cw || !ch) return;
      const w = Math.min(cw, ch * ratio);
      setBox({ w: Math.round(w), h: Math.round(w / ratio) });
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ratio]);
  return [ref, box];
};

const RATIOS = { square: 1, vertical: 9 / 16 };

export const PreviewStage = ({ file, filter, format }) => {
  const ratio = RATIOS[format] || (file ? file.width / file.height : 16 / 9);
  const [ref, box] = useFitBox(ratio);
  const cropped = format !== "original";
  const style = { filter, objectFit: cropped ? "cover" : "contain" };
  return (
    <div className="frz-stage-area" ref={ref} data-testid="preview-stage">
      {file && (
        <div className="frz-frame" style={{ width: box.w, height: box.h }} data-testid={`preview-frame-${format}`}>
          {file.kind === "video" ? (
            <video key={file.id} src={fileUrl(file)} controls loop playsInline className="frz-frame-media" style={style} data-testid="preview-media" />
          ) : (
            <img key={file.id} src={fileUrl(file)} alt="preview" className="frz-frame-media" style={style} data-testid="preview-media" />
          )}
        </div>
      )}
    </div>
  );
};
